import axios from 'axios';
import { BACKEND_URL } from '@/config';

// Create a configured axios instance
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

// Add a request interceptor to automatically attach the JWT token if present
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('folio-token') || sessionStorage.getItem('folio-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add an interceptor to unwrap the `data` layer automatically
api.interceptors.response.use(
  (response) => {
    // response.data contains our C# ApiResponse { success, message, data, token }
    return response.data; 
  },
  (error) => {
    // If the server returns 400/401/500, we still want to grab our custom JSON message
    if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
    }
    return Promise.reject({ success: false, message: error.message });
  }
);

export default api;
